<app-page-header-png [isCurveGray]="true" header={{language.faqpagename}} backgroundPath="assets/images/lead/default.png">
</app-page-header-png>

<div class="container">
    <div class="row">
        <div class="col-12">

            <section class="section section-group section-table pt-0">

                <div class="row">
                    <div class="col-6">
                        <header>
                            <h2 class="topic-title">{{language.faqtitle}}</h2>
                        </header>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <div class="dropdown">
                                <button aria-expanded="false" aria-haspopup="true" class="select--button" data-toggle="dropdown" id="dropdownMenu2" type="button" role="button">
                                    <span>{{value || defaultTitle}} </span>
                                    <span>
                                        <img
                                            src="assets/images/icon/caret-down@2x.png"
                                            alt="arrow-dropdown" />
                                    </span>
                                </button>
                                <div aria-labelledby="dropdownMenu2" class="dropdown-menu" x-placement="bottom-start">
                                    <div class="bs-searchbox">
                                        <input aria-label="Search" autocomplete="on" class="form-control" role="textbox" [(ngModel)]="userFilter1.topic" type="text">
                                    </div>
                                    <ul aria-expanded="false" class="menu--list" role="listbox" style="max-height:
                                        450px; overflow-y: auto;" *ngFor="let
                                        group of title">
                                        <li class="dropdown-item w-dot
                                            selectpicker" style="height: auto;" data-original-index="1">
                                            <a aria-disabled="false" aria-selected="false" class="" (click)="scrollTo(group.id)" data-tokens="null" role="option" ta-tokens="null" tabindex="0">
                                                <span class="text">{{ group.topic }}</span>
                                                <span class="glyphicon
                                                    glyphicon-ok check-mark"></span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="container">
                    <div class="{{isCollapse ? 'collapsed': ''}}" id="{{group.id}}" *ngFor="let group of title | filterBy:
                        userFilter1" scrollSpy (sectionChange)="onSectionChange($event)">
                        <app-collapse-card-job header="{{ group.topic }}">
                            <ul *ngFor="let group2 of group.detail">
                                <li class="mt-3">
                                    <div class="detail" [innerHTML]="group2.name">
                                    </div>
                                </li>
                                <li *ngIf="(title | filterBy:userFilter1).length === 0">
                                    {{language.null}}
                                </li>
                            </ul>
                        </app-collapse-card-job>
                    </div>
                </div>
            </section>
        </div>
    </div>
</div>